// import './assets/App.scss'
// import './store'
// import './lang'

import actions from './actions'
import awsUtils from './utils/aws'
import validationUtils from './utils/validation'
import commonUtils from './utils/common'

// import AddButton from './components/common/button/Add.vue'
// import AllDeleteButton from './components/common/button/AllDelete.vue'
// import FormModal from './components/common/FormModal.vue'
import Loading from './components/common/Loading.vue'
// import Progessbar from './components/common/Progessbar.vue'
import AuthError from './components/error/AuthErrorModal.vue'
import GlobalError from './components/error/CommonErrorModal.vue'
import NetworkError from './components/error/NetworkErrorModal.vue'
// import AppModal from './components/header/AppModal.vue'
// import MainHeader from './components/header/MainHeader.vue'
// import NavLink from './components/navigation/NavLink.vue'
// import ManualContents from './components/views/help/ManualContents.vue'

const SinopsCloudWebLib = {
  install (Vue) {
    Vue.prototype.$actions = actions

    Vue.filter('addComma', val => {
      return parseFloat(val).toLocaleString()
    })

    Vue.directive('scroll', {
      inserted: (el, binding) => {
        const f = e => {
          if (binding.value(e, el)) {
            window.removeEventListener('scroll', f)
          }
        }
        window.addEventListener('scroll', f)
      }
    })

    Vue.mixin(awsUtils)
    Vue.mixin(validationUtils)
    Vue.mixin(commonUtils)

    const components = {
      // AddButton,
      // AllDeleteButton,
      // FormModal,
      Loading,
      // Progessbar,
      AuthError,
      GlobalError,
      NetworkError,
      // AppModal,
      // MainHeader,
      // NavLink,
      // ManualContents,
    }
    for (const [name, c] of Object.entries(components)) {
      Vue.component(name, c)
    }
  }
}

export default SinopsCloudWebLib
